import React from 'react';

const Footer = () => {
    return (
      <footer className='footer-container'>
        {" "}
        The website is created by{" "}
        <a href="https://www.linkedin.com/in/nataliia-zablotska/">
          Natalie Zablotska
        </a>
        . Data comes from{" "}
        <a href="https://www.frontendmentor.io/">FrontendMentor</a>
      </footer>
    );
}

export default Footer;